import type { AppModule } from '@/app/app-module.types';
import { CatalogIcon, DeliveryIcon } from '@/shared/icons';
import { TOTVS_INTEGRATOR_ROLES } from '@/shared/guards/roles';
import { totvsContainer } from './di/container';
import { TotvsRepositoryToken } from './di/tokens';
import { totvsRoutes } from './presentation/routes';

export const totvsModule: AppModule = {
  name: 'totvs',

  register(container) {
    container.register(TotvsRepositoryToken, () => totvsContainer.repository);
  },

  routes: totvsRoutes,

  menu: [
    {
      label: 'TOTVS Jobs',
      to: '/totvs/jobs',
      icon: DeliveryIcon,
      section: 'operations',
      order: 3,
      roles: TOTVS_INTEGRATOR_ROLES,
    },
    {
      label: 'TOTVS De-para (MCB)',
      to: '/totvs/product-links',
      icon: CatalogIcon,
      section: 'registry',
      order: 4,
      roles: TOTVS_INTEGRATOR_ROLES,
    },
  ],
};
